import { buildGuideLinks, buildVisualGuides } from "@plaatplan/i18n";

/**
 * @param {import("@plaatplan/i18n").InfoPagesCatalog} infoPages
 * @param {string} pageId
 * @param {string} [locale]
 */
export function getGuideHowTo(infoPages, pageId, locale = "nl") {
  const visualGuides = buildVisualGuides(locale);
  const guideMeta = buildGuideLinks(locale).find((guide) => guide.pageId === pageId);
  const howToName = guideMeta?.title.replace(/\s*\|\s*Plaatplan$/, "") ?? pageId;

  if (pageId === "how") {
    const guide = visualGuides.how;
    return {
      name: howToName,
      description: guide.intro,
      steps: guide.steps.map((step) => ({
        name: step.title,
        text: step.body,
      })),
    };
  }

  if (pageId === "werkplanExport") {
    const guide = visualGuides.werkplanExport;
    return {
      name: howToName,
      description: guide.intro,
      steps: guide.steps.map((step) => ({
        name: step.title,
        text: step.body,
      })),
    };
  }

  if (pageId === "cutSimulator") {
    const guide = visualGuides.cutSimulator;
    return {
      name: howToName,
      description: guide.intro,
      steps: guide.steps.map((step) => ({
        name: step.title,
        text: step.body,
      })),
    };
  }

  if (pageId === "importExport") {
    const page = infoPages.importExport;
    return {
      name: page.title,
      description: page.intro,
      steps: page.sections.map((section) => ({
        name: section.heading,
        text: section.paragraphs.join(" "),
      })),
    };
  }

  return null;
}
